const tokens = {
    ILLEGAL: 'ILLEGAL',
    EOF: 'EOF',
    SPACE: 'SPACE',
    // Conjunctions
    AND: 'AND',
    OR: 'OR',
    // Operators
    EQUALITY: ':',
    GREATER: '>',
    SMALLER: '<',
    RANGE: '..',
    // Identifiers / types
    NUMBER: 'number',
    STRING: 'string',
    BOOLEAN: 'boolean',
};
const operators = {
    ':': 'equality',
    '>': 'greater',
    '<': 'smaller',
};
export { tokens, operators };
